var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsorIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.674 64.18a16.003 16.003 0 0 0-16 0l-77.002 44.457c-19.754 11.405-38.736 16.491-61.547 16.491l-105.875-.002C42.729 125.126 0 167.854 0 220.375s42.729 95.249 95.25 95.249h12.449v93.304c0 22.627 18.409 41.036 41.036 41.036h24.756c8.836 0 16-7.163 16-16V315.623h11.638c22.809 0 41.791 5.086 61.545 16.491l77 44.457a15.991 15.991 0 0 0 16 0c4.95-2.858 8-8.141 8-13.856V78.036a16 16 0 0 0-8-13.856zM95.25 283.624c-34.876 0-63.25-28.373-63.25-63.249s28.374-63.249 63.249-63.249h12.449v126.498zm62.241 134.34h-8.756c-4.982 0-9.036-4.054-9.036-9.036v-93.304h17.792zm174.183-82.962-53-30.601c-24.554-14.176-49.195-20.778-77.545-20.778h-61.43V157.127l61.425.001c28.353 0 52.995-6.603 77.548-20.778l53.002-30.601zm138.091-24.07.188 7.771c.213 8.834-6.775 16.169-15.609 16.382-.131.003-.263.005-.394.005-8.657 0-15.778-6.911-15.988-15.613l-.199-8.218c-13.352-3.319-22.313-10.795-30.89-18.886-6.428-6.064-6.723-16.19-.659-22.618 6.064-6.427 16.19-6.723 22.618-.659 9.519 8.98 14.411 11.969 24.62 11.969 14.639 0 26.548-9.867 26.548-21.995s-11.909-21.995-26.548-21.995c-32.284 0-58.548-24.222-58.548-53.995 0-24.564 17.879-45.351 42.267-51.87l-.219-9.164c-.211-8.835 6.779-16.167 15.613-16.378 8.814-.186 16.167 6.779 16.378 15.613l.245 10.248c13.208 3.643 28.118 11.272 35.382 22.326 4.853 7.385 2.801 17.306-4.584 22.158-7.384 4.852-17.305 2.802-22.158-4.584-2.542-3.838-16.812-10.344-24.375-10.344-14.639 0-26.548 9.866-26.548 21.994s11.91 21.995 26.548 21.995c32.283 0 58.548 24.222 58.548 53.995-.001 24.553-17.865 45.332-42.236 51.863z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorIcons);
export default __webpack_public_path__ + "static/media/sponsor-icons.823617a75f38c79bb844c1cc12be1656.svg";
export { ForwardRef as ReactComponent };